import Icon from './Icon';
export default Icon;
//# sourceMappingURL=index.js.map